import _ from 'lodash'
import moment from 'moment'
// import I18n from 'e_i18n'
import { ENERGY_GRAPH, ENERGY_TYPE, MOMENT_JS_FORMAT, CUSTOM_TYPE, UNITS } from './constant'

const getArrayIndividualCalcValue = (arr1, arr2, op) => {
  var op = op ? op : '+'
  var arrA = arr1
  var arrB = arr2
  if (arr1.length < arr2.length) {
    arrA = arr2
    arrB = arr1
  }

  return _.map(arrA, function (gh, i) {
    var a1 = gh
    var a2 = arrB[i]
    if (!a1 || isNaN(a1)) a1 = 0
    if (!a2 || isNaN(a2)) a2 = 0
    return a1 + a2
  })
}

const getUpdatedDate = (date, customType) => {
  if (!date) return date

  switch (customType) {
    case CUSTOM_TYPE.LIFETIME:
      date.set({ year: date.year() + 1 })
      return date
    case CUSTOM_TYPE.YEAR:
      date.set({ month: date.month() + 1 })
      return date
    case CUSTOM_TYPE.MONTH:
      date.set({ day: date.day() + 1 })
      return date
    case CUSTOM_TYPE.WEEK:
      date.set({ day: date.day() + 1 })
      return date
    default:
      date.set({ minute: date.minute() + 15 })
      return date
  }

}

const makeSeriesData = (date, energyType, data, customType) => {
  const start = date
  let key = 0
  let color = '#F2F2F2'
  const stroke = '#FFFFFF'
  let opacity = ENERGY_GRAPH.OPACITY.MAX
  let convertToNegative = false

  switch (energyType) {
    case ENERGY_TYPE.PRODUCTION.KEY:
      key = ENERGY_TYPE.PRODUCTION.SNO
      color = ENERGY_GRAPH.COLOR.PRODUCTION
      break
    case ENERGY_TYPE.CONSUMPTION.KEY:
      key = ENERGY_TYPE.CONSUMPTION.SNO
      color = ENERGY_GRAPH.COLOR.CONSUMPTION
      convertToNegative = true
      break
    case ENERGY_TYPE.IMPORTED.KEY:
      key = ENERGY_TYPE.IMPORTED.SNO
      color = ENERGY_GRAPH.COLOR.IMPORTED
      break
    case ENERGY_TYPE.EXPORTED.KEY:
      key = ENERGY_TYPE.EXPORTED.SNO
      color = ENERGY_GRAPH.COLOR.EXPORTED
      convertToNegative = true
      break
    case ENERGY_TYPE.BATTERY_CHARGED.KEY:
      key = ENERGY_TYPE.BATTERY_CHARGED.SNO
      color = ENERGY_GRAPH.COLOR.BATTERY_CHARGED
      convertToNegative = true
      break
    case ENERGY_TYPE.BATTERY_DISCHARGED.KEY:
      key = ENERGY_TYPE.BATTERY_DISCHARGED.SNO
      color = ENERGY_GRAPH.COLOR.BATTERY_DISCHARGED
      break
    case ENERGY_TYPE.BATTERY_STATUS.KEY:
      key = ENERGY_TYPE.BATTERY_STATUS.SNO
      color = ENERGY_GRAPH.COLOR.BATTERY_STATUS
      break
    case ENERGY_TYPE.GENERATOR.KEY:
      key = ENERGY_TYPE.GENERATOR.SNO
      color = ENERGY_GRAPH.COLOR.GENERATOR_DAY
      break
    default:
  }

  const processedData = []
  let dataDateTime = start.clone()
  let graphEnd = data.length - 1
  for (let i = data.length - 1; i >= 0; i -= 1) {
    if (data[i] && data[i] !== 0) {
      graphEnd = i
      break
    }
  }
  for (let i = 0; i < data.length; i += 1) {
    const x = dataDateTime ? dataDateTime.unix() : 0
    const y = data[i] ? data[i] : 0
    const selectedDate = date.format(MOMENT_JS_FORMAT.DATE_US)
    const timestampDate = moment.unix(x).format(MOMENT_JS_FORMAT.DATE_US)
    const canAddData = customType === CUSTOM_TYPE.DAY ? date && moment(selectedDate).isSame(timestampDate) : date

    if (canAddData) {
      processedData.push({
        x,
        y: convertToNegative ? -y : y,
        key,
        color,
        stroke,
        opacity,
        date: dataDateTime.clone().utc().format(MOMENT_JS_FORMAT.DATE_US_DASH_SEPARATOR),
        end: graphEnd >= i,
        value: y
      })

      dataDateTime = getUpdatedDate(dataDateTime, customType)
    }
  }

  return processedData
}

const makeXTickValue = (data, customType) => {
  let tickValues = []
  let xAxisTickValueEnergy = []
  tickValues = _.chain(data)
    .union(
      data.production,
      data.consumption,
      data.imported,
      data.exported,
      data.battery_charged,
      data.battery_discharged,
      data.generator,
    )
    .map(obj => obj.x)
    .uniq()
    .value()
  if (tickValues.length > 0) {
    let date = moment.unix(_.first(tickValues))
    xAxisTickValueEnergy = _.filter(tickValues, (x) => {
      if (x === date.unix()) {
        switch (customType) {
          case CUSTOM_TYPE.LIFETIME:
            date.add(1, 'year')
            return x
          case CUSTOM_TYPE.YEAR:
            date.add(1, 'month')
            return x
          case CUSTOM_TYPE.MONTH:
            date.add(1, 'day')
            return x
          case CUSTOM_TYPE.WEEK:
            date.add(1, 'day')
            return x
          default:
            date.add(3, 'hours')
            return x
        }
      }
    })
  } else {
    xAxisTickValueEnergy = []
  }
  return xAxisTickValueEnergy
}

const processGraphData = (data) => {
  const graphDataProcessed = {}
  _.each(data, (keyValue, key) => {
    const valueArray = keyValue
    graphDataProcessed[key] = makeSeriesData(moment().startOf('day'), key, valueArray)
  })

  return graphDataProcessed
}

const processDayGraphData = (data, date, customType) => {
  const graphDataProcessed = {}
  _.each(data, (keyValue, key) => {
    const valueArray = keyValue
    graphDataProcessed[key] = makeSeriesData(date, key, valueArray, customType)
  })

  return graphDataProcessed
}

const getOneDayParsedData = (dayData) => {
  function emptyArr() {
    const arr = []
    let count = 0
    const n = 95
    while (count < n) { arr[count += 1] = 0 }

    return arr
  }
  const importedData = getArrayIndividualCalcValue((dayData && dayData.grid_home) || [], (dayData && dayData.grid_battery) || [])
  const exportedData = getArrayIndividualCalcValue((dayData && dayData.solar_grid) || [], (dayData && dayData.battery_grid) || [])
  const netEnergy = exportedData.map((item, index) => item - importedData[index])
  const selectedEnergyValues = {
    production: (dayData && dayData.production) || emptyArr(),
    consumption: (dayData && dayData.consumption) || emptyArr(),
    imported: importedData || emptyArr(),
    exported: exportedData || emptyArr(),
    battery_charged: (dayData && dayData.charge) || emptyArr(),
    battery_discharged: (dayData && dayData.discharge) || emptyArr(),
    generator: (dayData && dayData.generator) || emptyArr(),
    battery_status: (dayData && dayData.soc) || emptyArr(),
    net_energy: netEnergy || emptyArr(),
  }

  return selectedEnergyValues
}

const getCustomParsedData = (data, dateDiff, value) => {
  const selectedEnergyValues = {
    production: [],
    consumption: [],
    imported: [],
    exported: [],
    battery_charged: [],
    battery_discharged: [],
    battery_status: [],
    net_energy: [],
    generator: [],
  }

  const importedData = getArrayIndividualCalcValue((data && data.grid_home) || [], (data && data.grid_battery) || [])
  const exportedData = getArrayIndividualCalcValue((data && data.solar_grid) || [], (data && data.battery_grid) || [])

  const energyValues = selectedEnergyValues

  const initialValue = dateDiff
  const valueLength = dateDiff + value
  for (let i = initialValue; i < valueLength; i++) {
    const currentExportedData = (exportedData && exportedData[i]) || 0
    const currentImportedData = (importedData && importedData[i]) || 0
    energyValues.production.push((data && data.production && data.production[i]) || 0)
    energyValues.consumption.push((data && data.consumption && data.consumption[i]) || 0)
    energyValues.imported.push(currentImportedData)
    energyValues.exported.push(currentExportedData)
    energyValues.battery_charged.push((data && data.charge && data.charge[i]) || 0)
    energyValues.battery_discharged.push((data && data.discharge && data.discharge[i]) || 0)
    energyValues.generator.push((data && data.generator && data.generator[i]) || 0)
    energyValues.net_energy.push(currentExportedData - currentImportedData || 0)
  }

  return selectedEnergyValues
}

const getYearParsedData = (data, dateDiff, startDate) => {
  const selectedEnergyValues = {
    production: [],
    consumption: [],
    imported: [],
    exported: [],
    battery_charged: [],
    battery_discharged: [],
    battery_status: [],
    net_energy: [],
    generator: [],
  }

  const importedData = getArrayIndividualCalcValue((data && data.grid_home) || [], (data && data.grid_battery) || [])
  const exportedData = getArrayIndividualCalcValue((data && data.solar_grid) || [], (data && data.battery_grid) || [])

  const energyValues = selectedEnergyValues

  let initialValue = dateDiff
  let valueLength = 0
  let months = 12
  while (initialValue < 0 && months > 0) {
    let currentExportedData = 0
    let currentImportedData = 0
    let productionData = 0
    let consumptionData = 0
    let batteryChargedData = 0
    let batteryDischargeData = 0
    let generatorData = 0
    let netEnergyData = 0
    let monthEndDate = moment(startDate).add(1, 'month')
    let monthLength = 0
    monthLength = moment(startDate).add(1, 'month').diff(moment(startDate), 'days', [])
    valueLength += monthLength
    let i = initialValue
    while (valueLength > 0) {
      currentExportedData += (exportedData && exportedData[i]) || 0
      currentImportedData += (importedData && importedData[i]) || 0
      productionData += (data && data.production && data.production[i]) || 0
      consumptionData += (data && data.consumption && data.consumption[i]) || 0
      batteryChargedData += (data && data.charge && data.charge[i]) || 0
      batteryDischargeData += (data && data.discharge && data.discharge[i]) || 0
      generatorData += (data && data.generator && data.generator[i]) || 0
      netEnergyData += (currentExportedData - currentImportedData || 0)
      valueLength--
      i++
    }
    initialValue += monthLength
    startDate = monthEndDate
    energyValues.production.push(productionData)
    energyValues.consumption.push(consumptionData)
    energyValues.imported.push(currentImportedData)
    energyValues.exported.push(currentExportedData)
    energyValues.battery_charged.push(batteryChargedData)
    energyValues.battery_discharged.push(batteryDischargeData)
    energyValues.generator.push(generatorData)
    energyValues.net_energy.push(netEnergyData)
    months--
  }
  valueLength = dateDiff < 0 ? 0 : dateDiff
  for (let month = 0; month < months; month++) {
    let currentExportedData = 0
    let currentImportedData = 0
    let productionData = 0
    let consumptionData = 0
    let batteryChargedData = 0
    let batteryDischargeData = 0
    let generatorData = 0
    let netEnergyData = 0
    let monthEndDate = moment(startDate).add(1, 'month')
    let monthLength = 0
    monthLength = moment(startDate).add(1, 'month').diff(moment(startDate), 'days', [])
    valueLength += monthLength
    for (let i = initialValue; i < valueLength; i++) {
      currentExportedData += (exportedData && exportedData[i]) || 0
      currentImportedData += (importedData && importedData[i]) || 0
      productionData += (data && data.production && data.production[i]) || 0
      consumptionData += (data && data.consumption && data.consumption[i]) || 0
      batteryChargedData += (data && data.charge && data.charge[i]) || 0
      batteryDischargeData += (data && data.discharge && data.discharge[i]) || 0
      generatorData += (data && data.generator && data.generator[i]) || 0
      netEnergyData += (currentExportedData - currentImportedData || 0)
    }
    initialValue += monthLength
    startDate = monthEndDate
    energyValues.production.push(productionData)
    energyValues.consumption.push(consumptionData)
    energyValues.imported.push(currentImportedData)
    energyValues.exported.push(currentExportedData)
    energyValues.battery_charged.push(batteryChargedData)
    energyValues.battery_discharged.push(batteryDischargeData)
    energyValues.generator.push(generatorData)
    energyValues.net_energy.push(netEnergyData)
  }

  return selectedEnergyValues
}

const getLifetimeParsedData = (data, dateDiff, startDate, totalYears) => {
  const selectedEnergyValues = {
    production: [],
    consumption: [],
    imported: [],
    exported: [],
    battery_charged: [],
    battery_discharged: [],
    battery_status: [],
    net_energy: [],
    generator: [],
  }

  const importedData = getArrayIndividualCalcValue((data && data.grid_home) || [], (data && data.grid_battery) || [])
  const exportedData = getArrayIndividualCalcValue((data && data.solar_grid) || [], (data && data.battery_grid) || [])

  const energyValues = selectedEnergyValues

  let initialValue = dateDiff
  let valueLength = dateDiff < 0 ? 0 : dateDiff
  for (let year = 0; year <= totalYears; year++) {
    let currentExportedData = 0
    let currentImportedData = 0
    let productionData = 0
    let consumptionData = 0
    let batteryChargedData = 0
    let batteryDischargeData = 0
    let generatorData = 0
    let netEnergyData = 0
    let yearEndDate = moment(startDate).add(1, 'year')
    let yearLength = 0
    yearLength = moment(startDate).add(1, 'year').diff(moment(startDate), 'days', [])
    valueLength += yearLength
    for (let i = initialValue; i < valueLength; i++) {
      currentExportedData += (exportedData && exportedData[i]) || 0
      currentImportedData += (importedData && importedData[i]) || 0
      productionData += (data && data.production && data.production[i]) || 0
      consumptionData += (data && data.consumption && data.consumption[i]) || 0
      batteryChargedData += (data && data.charge && data.charge[i]) || 0
      batteryDischargeData += (data && data.discharge && data.discharge[i]) || 0
      generatorData += (data && data.generator && data.generator[i]) || 0
      netEnergyData += (currentExportedData - currentImportedData || 0)
    }
    initialValue += yearLength
    startDate = yearEndDate
    energyValues.production.push(productionData)
    energyValues.consumption.push(consumptionData)
    energyValues.imported.push(currentImportedData)
    energyValues.exported.push(currentExportedData)
    energyValues.battery_charged.push(batteryChargedData)
    energyValues.battery_discharged.push(batteryDischargeData)
    energyValues.generator.push(generatorData)
    energyValues.net_energy.push(netEnergyData)
  }
  return selectedEnergyValues
}

const getEmptyGraphData = (data, xTick, customType) => {
  const values = []
  let countStart = 1
  let countEnd = 0
  if (data) {
    countEnd = (data.consumption && data.consumption.length)
      || (data.production && data.production.length)
      || (data.imported && data.imported.length)
      || (data.exported && data.exported.length)
  }

  let start = _.first(xTick)
  start = moment.unix(start)

  while (countStart <= countEnd) {
    values.push({ x: start.unix(), y: 0 })
    start = getUpdatedDate(start, customType)
    countStart += 1
  }
  if (values.length < 1) {
    values.push({ x: 0, y: 0 })
  }

  return values
}

const getMaxValueBasedOnKey = (key, data) => {
  const value = !_.isEmpty(data) ? Math.max.apply(Math, data.map(obj => obj.y)) : 0
  return value ? Math.abs(value) : 0
}

const getYScale = (data) => {
  if (data) {
    let maxValue = 0

    const maxPositive = (getMaxValueBasedOnKey('y', data.production)
      + getMaxValueBasedOnKey('y', data.imported)
      + getMaxValueBasedOnKey('y', data.battery_discharged)
      + getMaxValueBasedOnKey('y', data.generator))

    const maxNegative = (getMaxValueBasedOnKey('y', data.consumption)
      + getMaxValueBasedOnKey('y', data.exported)
      + getMaxValueBasedOnKey('y', data.battery_charged))
    maxValue = maxPositive > maxNegative ? maxPositive : maxNegative

    const maxValueYAxis = maxValue + (maxValue === 0 ? 999 : 0)
    return {
      min: 0,
      max: maxValueYAxis,
    }
  }

  return {
    min: 0,
    max: 999,
  }
}

const round = (number, precision) => {
  var multiple = Math.pow(10, precision)
  return Math.round(number * multiple) / multiple
}

const lookup = (value, unit) => {
  var result, total, scale

  if (unit === 'wattHours') {
    scale = [
      { selector: 'kWh', max: 999, value: 1000, precision: 2 },
      { selector: 'MWh', max: 999, value: 1000000, precision: 2 },
      { selector: 'GWh', max: null, value: 1000000000, precision: 2 }
    ]
  } else {
    scale = [
      { selector: 'kW', max: 999, value: 1000, precision: 2 },
      { selector: 'MW', max: 999, value: 1000000, precision: 2 },
      { selector: 'GW', max: null, value: 1000000000, precision: 2 }
    ]
  }

  result = _.find(scale, function (unit) {
    total = unit.value * (unit.max || Infinity)
    return Math.abs(value) <= total
  })
  return _.clone(result || _.first(scale))
}

const getFixedValue = (value, precision = 2) => {
  if (value || value >= 0) {
    let valueToChange = value.toString()
    valueToChange = valueToChange.split(',')
    valueToChange = valueToChange.join('.')
    valueToChange = parseFloat(valueToChange).toFixed(precision)
    return valueToChange
  }
  return value
}

const convertEnergyValue = value => getFixedValue(value, 1)

const convertUnits = (value, units) => {
  const unit = lookup(value, units)
  let precision = unit.precision

  if (_.isNumber(value)) {
    unit.number = value / unit.value
    unit.converted = round(unit.number, precision)

    if (unit.converted === 0) {
      precision = 0
    }

    unit.display = unit.converted
    unit.absDisplay = Math.abs(unit.converted)
    unit.absDisplay = convertEnergyValue(unit.absDisplay)
    unit.converted = Math.abs(unit.converted)
    unit.unit = unit.converted === 0 ? '' : (unit.converted === 1) ? UNITS[unit.selector].single : UNITS[unit.selector].plural
    unit.abv = UNITS[unit.selector].abv || unit.unit
  } else {
    unit.display = unit.absDisplay = unit.converted = '--'
    unit.number = value
    unit.abv = ''
  }
  unit.raw = value
  return unit
}

export {
  getArrayIndividualCalcValue,
  getOneDayParsedData,
  processGraphData,
  makeXTickValue,
  getCustomParsedData,
  getYearParsedData,
  getLifetimeParsedData,
  getEmptyGraphData,
  getYScale,
  processDayGraphData,
  convertUnits
}